import styled from 'styled-components';

const ImageLeaderboardItem = styled.img`
  vertical-align: middle;
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;

export default ImageLeaderboardItem;
